/* @flow */
import * as React from 'react';
import { useSelector } from 'react-redux';

// Styles
import styles from './BraindateParticipantsItemTopics.style';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

// Utils
import { getUserId } from '@braindate/domain/lib/user/util';
import { getUsersTopicsCount } from 'src/shared/domain/topic/selector/topicSelectors';

// Components
import { Skeleton } from '@mui/material';

// Types
import type { User } from '@braindate/domain/lib/user/type';
import { useId } from 'react-aria';

type Props = {
  participant: User,
  isFetching?: boolean,
  title?: string,
};

const useStyles = createUseThemeStyles(styles);

const BraindateParticipantsItemTopics = ({
  participant,
  isFetching,
  title,
}: Props) => {
  const classes = useStyles();
  const titleId = useId();

  const userTopicsCount = useSelector(
    getUsersTopicsCount(getUserId(participant)),
  );

  return (
    <div>
      {!!title && (
        <p className={classes.title} id={titleId}>
          {title}
        </p>
      )}
      <span className={classes.root} aria-describedby={titleId}>
        {isFetching ? <Skeleton width={25} height={35} /> : userTopicsCount}
      </span>
    </div>
  );
};

export default React.memo<Props>(BraindateParticipantsItemTopics);
